import { InstantSearch } from 'react-instantsearch';

import { useTranslation } from '@klv/hooks/useTranslation';

import UnifiedSearchForm from './unified-search-form';

import { Breadcrumbs } from '@klaviyo-mkt/gatsby-components/molecules/breadcrumbs';
import { useShouldDisplayBreadcrumbs } from '@klaviyo-mkt/gatsby-theme-marketing/src/hooks/useBreadcrumbs';
import { searchClient } from '@klv/utils/search-client';

import type { IUnifiedSearchProps } from './types';


const UnifiedSearch = ({
  backgroundColor = 'light',
  defaultIndex,
  defaultViewType,
  userCourseData,
  viewedResources,
}: IUnifiedSearchProps) => {
  const { t, i18n } = useTranslation();
  const { shouldShowBreadcrumbs, homePrefix } = useShouldDisplayBreadcrumbs('/search-all', 'default', true, i18n.language);
  
  return (
    <InstantSearch searchClient={searchClient} insights>
      { shouldShowBreadcrumbs && <Breadcrumbs colorVariant={backgroundColor} breadcrumbs={[{ link: homePrefix || '/', text: t('breadcrumbs_home') }, { text: t('breadcrumbs_searchAll') }]} /> }
      <UnifiedSearchForm
        backgroundColor={backgroundColor}
        defaultIndex={defaultIndex}
        defaultViewType={defaultViewType}
        userCourseData={userCourseData }
        viewedResources={viewedResources}
      />
    </InstantSearch>
  );
};

export default UnifiedSearch;
